import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  SimpleChanges
} from '@angular/core';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

export enum TypeEnum {
  BE = 'BUEN ESTADO',
  ME = 'MAL ESTADO',
  NC = 'NO CALIDAD',
  MS = 'MAL SELLO'
}

export enum ReturnTypeClassEnum {
  CP = 'CAMBIO PRODUCTO',
  DE = 'DEVOLUCIONES'
}

@Component({
  selector: 'app-change-condition-filters',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './change-condition-filters.component.html',
  styleUrls: ['./change-condition-filters.component.scss'],
})
export class ChangeConditionFiltersComponent {
  @Input() form!: FormGroup;
  @Input() changeConditionClass: boolean = false;
  @Input() changeConditionType: boolean = false;

  searchChangeConditionType: string = '';

  filteredChangeConditionTypeList: any[] = [];

  changeConditionTypeList = this.getEnumOptions(TypeEnum);
  changeConditionClassList = this.getEnumOptions(ReturnTypeClassEnum);

  ngOnInit() {
    if (this.changeConditionClass) {
      this.changeConditionClassList = this.getEnumOptions(ReturnTypeClassEnum);
      // this.modelList = Object.entries(SubRouteModelEnum).map(([key, value]) => ({
      //   key: key as SubRouteModelEnum,
      //   value,
      // }));
    }
    if (this.changeConditionType) {
      this.changeConditionTypeList = this.getEnumOptions(TypeEnum);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['changeConditionType']) {
      this.filteredChangeConditionTypeList = [...this.changeConditionTypeList];
    }
  }

  getDisplayValue(list: any[], selectedIds: any[], key: string): string {
    if (!selectedIds || selectedIds.length === 0) return '';
    return list
      .filter(item => selectedIds.includes(item._id))
      .map(item => item[key])
      .join(', ');
  }

  filterChangeConditionType(search: string): void {
    const value = search?.toLowerCase() ?? '';

    if (value === '') {
      this.filteredChangeConditionTypeList = this.changeConditionTypeList;
    } else {
      this.filteredChangeConditionTypeList = this.changeConditionTypeList.filter(item =>
        item.label?.toLowerCase().includes(value)
      );
    }
  }

  // Función para obtener las opciones de un enum
  getEnumOptions(enumObj: any): { value: string, label: string }[] {
    return Object.keys(enumObj)
      .filter(key => isNaN(Number(key))) // Filtra las claves numéricas en caso de enums numéricos
      .map(key => ({
        value: key, // 'BE', 'ME', etc.
        label: enumObj[key] as string // 'BUEN ESTADO', 'MAL ESTADO', etc.
      }));
  }

}
